import axios from 'axios'
import { ElMessage } from 'element-plus'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 300000,
})

service.interceptors.request.use(
  (config) => {
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

service.interceptors.response.use(
  (res) => {
    return res
  },
  (error) => {
    if (error.response.data.status === false && error.response.data.message) {
      ElMessage({
        message: error.response.data.message,
        type: 'error',
      })
      return Promise.reject(error.response.data)
    }
    ElMessage({
      showClose: true,
      message: error.message,
      type: 'error',
    })
    throw Promise.reject(error.response.data)
  },
)

export default service
